const CharpenteBanner = () => {

    return(
        <>
            <section className="be-banner">
                <div className="">
                    <p className="be-banner-title">CHIFFRAGE : CHARPENTE TRADITIONNELLE</p>
                    <p className="be-centered-p">CHARPENTE</p>
                </div>
            </section>
        </>
    )

}

export default CharpenteBanner;